import f3tch from 'f3tch';

import API_URL from '../../constants/url.constant.api';
import profile from '../../profiles/json.profile.api';

const deleteNotificationApi = (id) =>
  f3tch(`/notifications/${id}`)
    .profile(profile({url: API_URL()}))
    .delete();

export default deleteNotificationApi;
